import React, {PropTypes} from 'react';

function AssessmentPersonal(props) {
  const {
    style: {
      color,
      backgroundColor
    } = {}
  } = props;

  return (
    <svg width="54px" height="73px" viewBox="0 0 54 73" version="1.1" xmlns="http://www.w3.org/2000/svg" >

<title>822E9C15-09BD-41CF-8542-99987FF1F85B</title>
  <desc>Created with sketchtool.</desc>
  <defs></defs>
  <g id="501---Assesments" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
  <g transform="translate(-816.000000, -450.000000)" id="Group-6" fill="#333333">
  <g transform="translate(740.000000, 405.000000)">
  <g id="icon_nurse" transform="translate(76.000000, 45.000000)">
  <g id="Icons">
  <g id="Group">
  <path d="M27,38.9333333 C21.4355455,38.9333333 16.1042727,36.5608333 12.3733636,32.4266 C9.14318182,28.8447333 7.36363636,24.2433 7.36363636,19.4666667 C7.36363636,8.73323333 16.173,0 27,0 C37.827,0 46.6363636,8.73323333 46.6363636,19.4666667 C46.6363636,24.2433 44.8568182,28.8447333 41.6266364,32.4266 C37.8957273,36.5608333 32.5644545,38.9333333 27,38.9333333 L27,38.9333333 Z M27,4.86666667 C18.8779091,4.86666667 12.2727273,11.4147667 12.2727273,19.4666667 C12.2727273,23.0436667 13.608,26.4941333 16.0330909,29.1829667 C18.8312727,32.2854667 22.8297273,34.0666667 27,34.0666667 C31.1702727,34.0666667 35.1687273,32.2854667 37.9669091,29.1829667 C40.392,26.4941333 41.7272727,23.0436667 41.7272727,19.4666667 C41.7272727,11.4147667 35.1220909,4.86666667 27,4.86666667 L27,4.86666667 Z" id="Shape"></path>
  <path d="M51.5454545,73 L2.45454545,73 C1.09963636,73 0,71.9098667 0,70.5666667 L0,53.2024 C0,43.8146 5.09809091,34.2978333 12.9894545,28.9615333 C14.1087273,28.2047667 15.6354545,28.4894667 16.4012727,29.6015 C17.1646364,30.7111 16.8774545,32.2246333 15.7557273,32.9838333 C9.26836364,37.3687 4.90909091,45.4960333 4.90909091,53.2024 L4.90909091,68.1333333 L49.0909091,68.1333333 L49.0909091,53.2024 C49.0909091,45.4960333 44.7316364,37.3711333 38.2467273,32.9814 C37.125,32.2222 36.8378182,30.7086667 37.6011818,29.5990667 C38.367,28.4894667 39.8912727,28.2023333 41.013,28.9591 C48.9019091,34.2978333 54,43.8146 54,53.2024 L54,70.5666667 C54,71.9098667 52.9003636,73 51.5454545,73 L51.5454545,73 Z" id="Shape"></path>
  <g transform="translate(24.545455, 41.366667)" id="Shape">
  <path d="M9.81818182,19.4666667 C8.46327273,19.4666667 7.36363636,18.3765333 7.36363636,17.0333333 L7.36363636,2.43333333 C7.36363636,1.09013333 8.46327273,0 9.81818182,0 C11.1730909,0 12.2727273,1.09013333 12.2727273,2.43333333 L12.2727273,17.0333333 C12.2727273,18.3765333 11.1730909,19.4666667 9.81818182,19.4666667 L9.81818182,19.4666667 Z"></path>
  <path d="M17.1818182,12.1666667 L2.45454545,12.1666667 C1.09963636,12.1666667 0,11.0765333 0,9.73333333 C0,8.39013333 1.09963636,7.3 2.45454545,7.3 L17.1818182,7.3 C18.5367273,7.3 19.6363636,8.39013333 19.6363636,9.73333333 C19.6363636,11.0765333 18.5367273,12.1666667 17.1818182,12.1666667 L17.1818182,12.1666667 Z"></path>
  </g>
  </g>
  </g>
  </g>
  </g>
  </g>
  </g>
  </svg>
  );
}

AssessmentPersonal.propTypes = {
  style: PropTypes.object
};

export default AssessmentPersonal;



// WEBPACK FOOTER //
// ./shared/common/svgs/AssessmentPersonal.js